import { ChangeTracker } from '../../../common/models/hooks/ChangeTracker';
import { RecruitWizardAiConfigOptions } from '../../../common/models/Configuration/RecruitWizardAi';

export const DefaultOptions: RecruitWizardAiConfigOptions = {
  RecruitWizardAiPrompt_JobAdCreation: '',
};

export const NoChangesTracker: ChangeTracker<RecruitWizardAiConfigOptions> = {
  RecruitWizardAiPrompt_JobAdCreation: false,
};
